export default function leaders() {

  $('.leader-box').each(function(e) {
    $(this).on('click', function(e) {
      const contentBox =  $(this).parent().next('.content-box');
      contentBox.children('.text').children('.content').empty();
      contentBox.attr('id', $(this).data('name'));
      contentBox.children('.img').children('img').attr('src', $(this).data('img'));
      contentBox.children('.text').children('.name').text($(this).data('name'));
      contentBox.children('.text').children('.position').text($(this).data('position'));
      contentBox.children('.text').children('.content').append($(this).data('content'));
      $('.leader-box').not($(this)).removeClass('active');
      $('.content-box').not($(contentBox)).removeClass('selected');
      $(this).addClass('active');
      contentBox.addClass('selected');
    })
  })
}


// WEBPACK FOOTER //
// ./scripts/modules/about-us.js